import { render } from "./BrokerSideMenu.vue?vue&type=template&id=73af63e8"
import script from "./BrokerSideMenu.vue?vue&type=script&lang=js"
export * from "./BrokerSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__